// Wizard Step 4 — configure data-visibility scope and optional
// department/branch overrides for the selected role.
export default function DataAccessView({
  selectedRoleForAccess,
  wizardRoleId,
  dataAccess,
  branches,
  departments,
  onDataAccessChange,
  onDataAccessItemToggle,
  onSubmit,
  onCancel,
  showInlineActions = true,
  readOnly = false,
}) {
  const roleId = selectedRoleForAccess || wizardRoleId;

  if (!roleId) {
    return (
      <p className="text-gray-500 text-center py-4">
        Please select a role to configure data access
      </p>
    );
  }

  const currentDataAccess = dataAccess[roleId] || {};
  const selectedItems = currentDataAccess.selectedItems || [];

  const levels = [
    { value: "own", label: "Own data only" },
    { value: "team", label: "Team data" },
    { value: "department", label: "Department data" },
    { value: "branch_location", label: "Branch / Location data" },
    { value: "all", label: "All company data" },
  ];

  const showPicker =
    currentDataAccess.level === "department" ||
    currentDataAccess.level === "branch_location";
  const pickerItems =
    currentDataAccess.level === "department" ? departments : branches;
  const pickerTitle =
    currentDataAccess.level === "department"
      ? "Select Departments"
      : "Select Branches/Locations";

  return (
    <div className="h-full overflow-y-auto">
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="border border-gray-300 p-4">
          <h4 className="font-semibold mb-3">Data Access Level</h4>
          <div className="space-y-2">
            {levels.map((level) => (
              <label
                key={level.value}
                className="flex items-center space-x-2 cursor-pointer"
              >
                <input
                  type="radio"
                  name="dataAccessLevel"
                  value={level.value}
                  checked={currentDataAccess.level === level.value}
                  disabled={readOnly}
                  onChange={(e) =>
                    onDataAccessChange(roleId, "level", e.target.value)
                  }
                  className="w-4 h-4"
                />
                <span className="text-sm">{level.label}</span>
              </label>
            ))}
          </div>
        </div>

        {showPicker && (
          <div className="border border-gray-300 p-4">
            <h4 className="font-semibold mb-3">{pickerTitle}</h4>
            <div className="space-y-2 max-h-60 overflow-y-auto">
              {pickerItems.map((item) => (
                <label
                  key={item.id}
                  className="flex items-center space-x-2 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={selectedItems.includes(item.id)}
                    disabled={readOnly}
                    onChange={(e) =>
                      onDataAccessItemToggle(roleId, item.id, e.target.checked)
                    }
                    className="w-4 h-4"
                  />
                  <span className="text-sm">{item.name}</span>
                </label>
              ))}
            </div>
          </div>
        )}

        {showInlineActions && (
          <div className="flex justify-end space-x-2 pt-4 border-t border-gray-300">
            <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-4 py-2 hover:bg-gray-600"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={readOnly}
              className="rh-btn-primary rounded-md px-4 py-2 hover:opacity-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-redhalo-red/40"
            >
              Save Data Access
            </button>
          </div>
        )}
      </form>
    </div>
  );
}
